import { render, staticRenderFns } from "./EditSeo.vue?vue&type=template&id=0499dc85&"
import script from "./EditSeo.vue?vue&type=script&lang=ts&"
export * from "./EditSeo.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports